import { VSCodeIpcContext } from "@/contexts/VSCodeIpcContext";
import { useContext } from "react";

export function useVSCodeIpcContext() {
    const ctx = useContext(VSCodeIpcContext);
    if (!ctx) {
        throw new Error("useVSCodeIpcContext must be used inside <VSCodeIpcProvider>");
    }
    return ctx;
}

export function useOptionalVSCodeIpcContext() {
    return useContext(VSCodeIpcContext);
}
